import React, { useEffect, useRef } from 'react';

const PromoBanner = ({ messages, autoplayDelay, colorScheme }) => {
  const swiperContainer = useRef(null);

  useEffect(() => {
    const swiperOptions = {
      slidesPerView: 1,
      centeredSlides: true,
      navigation: true,
      autoplay: {
        delay: autoplayDelay || 5000,
        disableOnInteraction: false,
      },
      loop: false,
      grabCursor: false,
      injectStyles: [
        `
        .swiper-button-prev, .swiper-button-next {
          width: 12px;
        }
        .swiper-button-prev svg, .swiper-button-next svg {
          width: auto;
          height: 12px;
        }
      `,
      ],
    };
    Object.assign(swiperContainer.current, swiperOptions);
    swiperContainer.current.initialize();
  }, []);

  return (
    <section
      data-section="promo-banner"
      // eslint-disable-next-line max-len
      className={`promo-banner--promo-banner color-${colorScheme} relative max-h-12 overflow-hidden overflow-x-hidden px-3 py-1.25 md:max-h-7.5 lg:px-8`}
      data-autoplay-delay={autoplayDelay}
    >
      <promo-banner>
        <div className="swiper">
          <swiper-container
            init="false"
            ref={swiperContainer}
          >
            {messages.map((message) => (
              <swiper-slide
                key={message}
                class="w-full self-center px-4 lg:px-2"
              >
                <div
                  dangerouslySetInnerHTML={{ __html: message }}
                  className="body-3 [&>a]:body-3-underline [&>strong]:body-3-bold text-center"
                />
              </swiper-slide>
            ))}
          </swiper-container>
        </div>
      </promo-banner>
    </section>
  );
};

export default PromoBanner;
